export default function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function")
        throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}
